export default () => {
  return {
    /**
     * Store for caching names of program targets
     */
    programTargetsCache: {},

    programTargetsPerProgramCache: {},
  };
};
